<template>
    <div class="main">
        <div class="body-content">
            <h1>Upload OVA Entry</h1>
            <div class="row">
                <div class="container">
                    <div class="form-group">
                        <label for="fileAdd">File:</label>
                        <input type="file" id="file" @change="handleFileUpload" class="custom-file-input">
                        <label>
                            <input type="checkbox" v-model="ovaflag" name="chkovaflag" value="1">
                            OVA Already Sent
                        </label>
                        <button type="button" class="excel-button" @click="uploadFiles" :disabled="isSubmitting">Upload</button>
                        <button type="button" class="excel-button" @click="savequery" :disabled="isSubmitting">Save</button>
                    </div>
                </div>
                <div class="form-item">
                    <div v-html="htmlContent"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="table-container">
        <table class="transaction-table table-design">
            <thead>
                <tr>
                    <th>
                        <span>Sl. No</span>
                    </th>
                    <th>
                        <span>Container</span>
                    </th>
                    <th>
                        <span>loc</span>
                    </th>
                    <th>
                        <span>movement</span>
                    </th>
                    <th>
                        <span>fl_mt_stat</span>
                    </th>
                    <th>
                        <span>ddt</span>
                    </th>
                    <th>
                        <span>tm</span>
                    </th>
                    <th>
                        <span>booking</span>
                    </th>
                    <th>
                        <span>seal</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="ld in fetchedList" :key="ld[0]" class="successful-task">
                    <td>{{ ld[0] }}</td>
                    <th>
                        <span>{{ ld[1] }}</span>
                    </th>
                    <th>
                        <span>{{ ld[2] }}</span>
                    </th>
                    <th>
                        <span>{{ ld[3] }}</span>
                    </th>
                    <th>
                        <span>{{ ld[4] }}</span>
                    </th>
                    <th>
                        <span>{{ ld[5] }}</span>
                    </th>
                    <th>
                        <span>{{ ld[6] }}</span>
                    </th>
                    <th>
                        <span>{{ ld[7] }}</span>
                    </th>
                    <th>
                        <span>{{ ld[7] }}</span>
                    </th>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from 'axios';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';

export default {
    data() {
        return {
            newContainer: {
                file: null,
            },
            ovaflag: false,
            htmlContent: null,
            uploadlist: [],
            sqlqry: null,
            isSubmitting: false,
        }
    },
    computed: {
        fetchedList() {
            //console.log(this.successfulTasks);
            //console.log(this.uploadlist);
            return this.uploadlist;
        },
    },
    methods: {
        handleFileUpload(event) {
            this.newContainer.file = event.target.files[0];
        },
        async uploadFiles() {
            if (this.isSubmitting) return;
            
            if (this.newContainer.file === null) {
                useToast().error('Please select a file to upload');
                return;
            }
            
            this.isSubmitting = true;
            try {
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                        'Content-Type': 'multipart/form-data'
                    },
                };
                //console.log(this.ovaflag)
                const data = new FormData();
                data.append('file', this.newContainer.file);
                const response = await axios.post('/upload_ova_transaction_entry?ovaflag=' + this.ovaflag, data, config);
                //console.log(response.data)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.uploadlist = response.data[2]
                    this.sqlqry = response.data[3]
                    //console.log(this.sqlqry)
                    //this.resetNewContainer();
                }
            } catch (error) {
                console.error('Error uploading files:', error);
                useToast().error('An error occurred while uploading files');
            } finally {
                this.isSubmitting = false;
            }
        },
        async savequery() {
            if (this.isSubmitting) return;
            
            if (this.sqlqry === null) {
                useToast().error('Please select a file to upload');
                return;
            }
            
            this.isSubmitting = true;
            try {
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                };
                const qrydata = {
                    qry:this.sqlqry
                }
                const data = new FormData();
                const transdt = JSON.stringify(qrydata)
                //console.log(this.sqlqry)
                //console.log(transdt)
                data.append('transaction', transdt)
                
                const response = await axios.post('/ova_transaction_entry_execute', data, config);
                //console.log(response.data)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.uploadlist = response.data[2]
                    this.sqlqry = response.data[3]
                    //console.log(this.sqlqry)
                    //this.resetNewContainer();
                }
            } catch (error) {
                console.error('Error saving data:', error);
                useToast().error('An error occurred while saving data');
            } finally {
                this.isSubmitting = false;
            }
        },
    }
}

</script>
<style scoped>
/* Form group styling for form elements */
.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 30%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
}
</style>